/*
 * Operating costs — live price.
 * Total = base price (this section) + every checked add-on checkbox on the page
 * ([data-pricing-addon], rendered by the "What's included" section).
 * Prices are handled in cents to avoid floating-point errors.
 */
(function () {
  if (window.__sectionOperatingCostsLoaded) return;
  window.__sectionOperatingCostsLoaded = true;

  var ROOT = '[data-section-operating-costs]';
  var ADDON = '[data-pricing-addon]';

  function formatPrice(cents, symbol) {
    return symbol + (cents / 100).toFixed(2);
  }

  function render(root) {
    var priceEl = root.querySelector('[data-operating-costs-price]');
    if (!priceEl) return;

    var total = parseInt(root.getAttribute('data-base-price-cents'), 10) || 0;
    document.querySelectorAll(ADDON).forEach(function (input) {
      if (input.checked) total += parseInt(input.getAttribute('data-addon-price-cents'), 10) || 0;
    });

    priceEl.textContent = formatPrice(total, root.getAttribute('data-currency-symbol') || '');
  }

  function renderAll(userAction) {
    document.querySelectorAll(ROOT).forEach(function (root) {
      render(root);
      if (
        userAction &&
        root.getAttribute('data-scroll-on-mobile') === 'true' &&
        window.innerWidth < 990
      ) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // Add-on toggled (event delegation, so it also works after theme-editor reloads)
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches(ADDON)) renderAll(true);
  });

  // Theme editor: sections re-rendered
  document.addEventListener('shopify:section:load', function () { renderAll(false); });

  // Initial state (covers add-ons that are "selected by default")
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { renderAll(false); });
  } else {
    renderAll(false);
  }
})();
